module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sales-book-preview mx-auto"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', {
    staticClass: "text-center mb-5"
  }, [_vm._v("Obrazac KPO")]), _vm._v(" "), _c('p', [_vm._v("PIB: " + _vm._s(_vm.company.taxNumber))]), _vm._v(" "), _c('p', [_vm._v("Obaveznik: " + _vm._s(_vm.company.owner))]), _vm._v(" "), _c('p', [_vm._v("Firma-radnje: " + _vm._s(_vm.company.name))]), _vm._v(" "), _c('p', [_vm._v("Sedište: " + _vm._s(_vm.company.address))]), _vm._v(" "), _c('p', [_vm._v("Šifra poreskog obveznika: " + _vm._s(_vm.company.registrationNumber))]), _vm._v(" "), _c('p', [_vm._v("Šifra delatnosti: " + _vm._s(_vm.company.classificationCode))]), _vm._v(" "), _c('h2', {
    staticClass: "text-center mb-5 mt-5"
  }, [_vm._v("Knjiga o ostvarenom prometu paušalno oporezovanih obveznika")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered mb-5"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice) {
    return _c('tr', [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(invoice.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("date")(invoice.deliveryDate)) + " " + _vm._s(invoice.client.name))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("decimal")(invoice.total)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("decimal")(invoice.total)))])])
  }), 0)]), _vm._v(" "), _c('p', [_vm._v("Sastavio: " + _vm._s(_vm.company.owner))]), _vm._v(" "), _c('p', [_vm._v("Odgovorno lice: " + _vm._s(_vm.company.owner))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2"
    }
  }, [_vm._v("Redni broj")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2"
    }
  }, [_vm._v("Datum i opis knjiženja")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "colspan": "2",
      "rowspan": "1"
    }
  }, [_vm._v("Prihod od delatnosti")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col",
      "rowspan": "2"
    }
  }, [_vm._v("Svega prihodi od delatnosti")])]), _vm._v(" "), _c('tr', {
    staticClass: "text-center"
  }, [_c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("od prodaje proizvoda")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("od izvršenih usluga")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36fe3ab4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SalesBookPreview.vue
// module id = 293
// module chunks = 1